export const environment = {
  production: false,
  api: 'https://api-masterboi.qualidadepereciveis.com.br',
  frontUrl: 'https://masterboi.qualidadepereciveis.com.br',
  supportApi: 'https://api-safetrack.safetrace.com.br',
  XAPIKEY: '489c4f76-1a13-4562-8b29-c0089cc2b01a',
  JSESSIONID: 'F46186D349D19ECF5F26083E1E342A02'
};
